const Status = Object.freeze({
    EM_EXECUCAO: "783a5f8a-684f-47f1-a700-a64fb6ab0279",
    EM_ANALISE: "29865708-9e7d-437f-9196-1f4e037dec28",
    PEDIDO_COLOCADO: "18ad60ed-258c-425e-8ecf-3f2afe7d9e05",
    CANCELADO: "5561f2c9-e92e-4838-9dba-fcee4fdc2235",
    PRORROGADO: "8ba06618-39b0-42eb-b70f-8c82b7106eb0",
    PERDIDO: "3fcf9e40-59a6-4683-b787-ca0d51cf72ff",
    DECLINADA: "a52a9711-63ee-4874-aefc-c3ed726bacc1",
    INICIADO: "4c2e9349-9a8c-4fce-aeac-976df49d13d3"
});

export {
    Status
};